import { Grid, Skeleton } from 'antd';
import { convertToArray } from 'mixins/helpers';
import ServiceGovItem from 'mixins/service-gov-item';
import React, { FC, useEffect, useState } from 'react';
import ServiceItem from '/react4xp/mixins/service-item';
import { getGovServices } from '/react4xp/parts/gov-services-admin/actions';
import { getImgUrl } from '/react4xp/parts/service-link-img/actions';
import '/site/parts/block-gov-service-list/block-gov-service-list.scss';

const { useBreakpoint } = Grid;

const BlockGovServiceList: FC = (props: any) => {
    const [list, setList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [img, setImg] = useState();
    const { md } = useBreakpoint();

    useEffect(() => {
        getGovServices(true)
            .then((value) => {
                if (value.data) {
                    const linksArrays = [
                        props.config.govServiceLink1,
                        props.config.govServiceLink2,
                        props.config.govServiceLink3,
                    ];
                    if (md) {
                        linksArrays.push(
                            ...[
                                props.config.govServiceLink4,
                                props.config.govServiceLink5,
                                props.config.govServiceLink6,
                            ]
                        );
                    }

                    let filteredList = [];

                    linksArrays.forEach((x) => {
                        const link = value.data.hits.find((y) => y.id === x);

                        if (link) {
                            filteredList.push(link);
                        }
                    });

                    setList(
                        filteredList.map((x) => {
                            const data = x[props.language];
                            return {
                                id: x.id,
                                name: data.name,
                                links: convertToArray(data.links),
                            };
                        })
                    );
                }
            })
            .finally(() => setIsLoading(false));

        if (props.image) {
            getImgUrl(props.image).then((value) => {
                if (value.data) {
                    setImg(value.data);
                }
            });
        }
    }, [md]);

    return (
        <div className="service-block">
            {img && (
                <img
                    className="me-2"
                    src={img}
                />
            )}

            <div className="service-block__title">{props.config.govServiceTitle}</div>

            {isLoading ? (
                <Skeleton
                    active
                    title={false}
                    paragraph={{ rows: 4 }}
                />
            ) : (
                list.map(
                    (x) =>
                        x && (
                            <ServiceGovItem
                                {...x}
                                key={x.id}
                            />
                        )
                )
            )}

            {props.config.govServicePageName && props.config.govServicePageUrl && (
                <ServiceItem
                    language={props.language}
                    url={props.config.govServicePageUrl}
                    name={props.config.govServicePageName}
                    position={'right'}
                />
            )}
        </div>
    );
};

export default BlockGovServiceList;
